import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'
import { ref } from 'vue'

const orders_of_service = ref([])
const total_orders_of_service = ref(0)
const order_of_service_filters = ref({})
const loading = ref(false)

export default function useOrdersOfService() {
  const {
    listRegisters,
    get_api_path,
    save_api_path,
    getAllRegisters,
    search_and_paginate_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  //all_registers_api_path.value = "/api/orders_of_service/all";
  search_and_paginate_api_path.value = '/api/orders_of_service/searchAndPaginate'
  get_api_path.value = '/api/orders_of_service/get/'
  save_api_path.value = '/api/orders_of_service/storeOrUpdate'
  destroy_api_path.value = '/api/orders_of_service/destroy/'

  const listOrdersOfService = async (page, per_page) => {
    loading.value = true

    return new Promise((resolve, reject) => {
      listRegisters(page, per_page, order_of_service_filters.value)
        .then((response) => {
          total_orders_of_service.value = response.data.meta.total
          orders_of_service.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
        .finally(() => (loading.value = false))
    })
  }

  const destroyOrderOfService = async (id, index) => {
    destroyRegister(id).then(() => {
      orders_of_service.value.splice(index, 1)
    })
  }

  return {
    orders_of_service,
    total_orders_of_service,
    order_of_service_filters,
    loading,
    listOrdersOfService,
    destroyOrderOfService,
    getAllOrdersOfService: getAllRegisters,
    saveOrderOfService: saveRegister,
    getOrderOfService: getRegister,
  }
}
